import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=f2fea04a&scoped=true&"
import script from "./CardAction.vue?vue&type=script&lang=js&"
export * from "./CardAction.vue?vue&type=script&lang=js&"
import style0 from "./CardAction.vue?vue&type=style&index=0&id=f2fea04a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fea04a",
  null
  
)

export default component.exports